import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

class FooterMenuLinkItem extends Component {
  constructor (props) {
    super(props)
    this.classConst =
      'col col-lg-auto pl-lg-1 pr-lg-4 px-4 px-md-2 txt-center txt-md-left txt-lg-left my-1 my-lg-0'
  }

  render () {
    return (
      <li className={this.props.item.className + this.classConst} data-href={this.props.item.dataHrefTo}>
        <Link
          className='color-ui-white txt-body-sm'
          to={this.props.item.dataHrefTo}
          tabIndex={0}
          target='_blank'
        >
          {this.props.item.description}
        </Link>
      </li>
    )
  }
}

FooterMenuLinkItem.propTypes = {
  item: PropTypes.object
}

export default FooterMenuLinkItem



// WEBPACK FOOTER //
// ./src/App/Footer/FooterMenuLinks/FooterMenuLinkItens/FooterMenuLinkItem.js